import { Action, action, createStore, createTypedHooks } from "easy-peasy";

export interface StoreState {
  searchTerm: string;
  updateSearchTerm: Action<StoreState, string>;
  seekToMs: number;
  seekTo: Action<StoreState, number>;
}

const store = createStore<StoreState>({
  searchTerm: "",
  updateSearchTerm: action((state, t) => {
    return {
      ...state,
      searchTerm: t,
    };
  }),
  seekToMs: -1,
  seekTo: action((state, ms) => {
    return {
      ...state,
      seekToMs: ms,
    };
  }),
});

const typedHooks = createTypedHooks<StoreState>();

export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
export const useStoreState = typedHooks.useStoreState;

export default store;
